var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChores({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5007 14.1673C15.1995 14.1673 13.334 12.3018 13.334 10.0007C13.334 7.69947 15.1995 5.83398 17.5007 5.83398",
    stroke: "#1E201C",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 17.5C13.3578 17.5 10 14.1422 10 10C10 5.85787 13.3578 2.5 17.5 2.5",
    stroke: "#1E201C",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 2.5V6.25M5 17.5V9.16667",
    stroke: "#1E201C",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 6.25H7.5",
    stroke: "#1E201C",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 2.5V6.12687C7.5 10.18 2.5 10.1799 2.5 6.12672V2.5",
    stroke: "#1E201C",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChores);
export default __webpack_public_path__ + "static/media/chores.c8bc1fca3cb68f3e06877f707d8bd896.svg";
export { ForwardRef as ReactComponent };